const bodyFont = 'Segoe UI, Roboto, Helvetica, Arial, sans-serif';
const specialFont = 'Ubuntu, Segoe UI, Roboto, Helvetica, Arial, sans-serif';
const verdanaFont = 'Verdana, Segoe UI, Roboto, Helvetica, Arial, sans-serif';

export { bodyFont, specialFont, verdanaFont };
